import { render } from "./App.vue?vue&type=template&id=e45cb4f6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e45cb4f6&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__